// 全局通用变量和方法存放处

/**
 * 服务器当前模式

2 - sqlserve生产
3 - sqlserve本地测试
 * 
 * 
 */

const serverModel = 2;

const baseURL = function() {
    let url = "http://www.liligc.com/hjrmanager-serve";
    if (serverModel == 1) {
        url = "http://www.liligc.com/hjrmanager-serve";
    } else if (serverModel == 2) {
        url = "http://www.liligc.com/hjrmanager-serveTest";
    } else if (serverModel == 3) {
        url = "http://127.0.0.1:10097";
    } else if (serverModel == 4) {
        url = "http://127.0.0.1:10097";
    }
    return url
}

const newCenterUrl = function() { // 张-后台地址
    let url = "https://www.liligc.com/NWCenter/dlApp";
    if (serverModel == 1) {
        url = "https://www.liligc.com/NWCenter/dlApp";
    } else if (serverModel == 2) {
        url = "https://www.liligc.com/NWCenter/dlAppTest";
    } else if (serverModel == 3) {
        url = "https://www.liligc.com/NWCenter/dlAppTest";
    } else if (serverModel == 4) {
        url = "https://www.liligc.com/NWCenter/dlApp";
    }
    return url
}


const serveBaseUrl_wang = function() {
    let url = "https://www.liligc.com/manage_serve/newCenter/";
    if (serverModel == 1) {
        url = "https://www.liligc.com/manage_serve/newCenter/";
    } else if (serverModel == 2) {
        url = "https://www.liligc.com/manage_serve/newCenter/";
    } else if (serverModel == 3) {
        url = "http://127.0.0.1:10097/hjrkj";
    } else if (serverModel == 4) {
        url = "http://127.0.0.1:10096/newCenter";
    } else if (serverModel == 5) {
        url = "https://www.liligc.com/manage_serve/newCenter/";
    }
    return url
}


const serveBaseUrl = function() {
    let url = "https://www.liligc.com/manage_serve/newCenter/";
    if (serverModel == 1) {
        url = "https://www.liligc.com/manage_serve/newCenter/";
    } else if (serverModel == 2) {
        url = "https://www.liligc.com/hjrmanager-serveTest/hjrkj";
    } else if (serverModel == 3) {
        url = "http://127.0.0.1:10097/hjrkj";
    } else if (serverModel == 4) {
        url = "http://127.0.0.1:10096/newCenter";
    } else if (serverModel == 5) {
        url = "https://www.liligc.com/hjrmanager-serve/hjrkj";
    }
    return url
}

const serveBaseUrl_old = function() {
    let url = "https://www.liligc.com/NWCenter/dlOrderMm";
    if (serverModel == 1) {
        url = "https://www.liligc.com/NWCenter/dlOrderMm";
    } else if (serverModel == 2) {
        url = "https://www.liligc.com/NWCenter/dlOrderMmTest";
    } else if (serverModel == 3) {
        url = "https://www.liligc.com/NWCenter/dlOrderMmTest";
    } else if (serverModel == 4) {
        url = "https://www.liligc.com/NWCenter/dlOrderMm";
    }else if (serverModel == 5) {
        url = "https://www.liligc.com/NWCenter/dlOrderMmSql";
    }
    return url
}

const customerPrve = function() { // 新服务器URL
    let url = "/customer";
    if (serverModel == 1) {
        url = "/customer";
    } else if (serverModel == 2) {
        url = "/customer-old";
    } else if (serverModel == 3) {
        url = "/customer-old";
    } else if (serverModel == 4) {
        url = "/customer";
    }
    return url
}


const imgPre = function() {
    let url = "http://www.liligc.com/manage_serve";
    return url
}

/* 2022-10-10
 统一产品图片处理方法：
 1.产品有图片的直接显示图片
 2.产品无图片的在预选的图片中进行随机选择,预选图片分组如下
   定制加工卷 ->卷料 图片开头为JL
   定制加工板 -> 板料 图片开头为BL
   特价材料三角板 ->三角板 图片开头为SJB
   特价材料异形板 ->异形板 图片开头为YXB
   特价材料条带 ->调大 图片开头为TD
   特价其他-> 特价  图片开头为TJ
   图片高清开头为HD 缩略默认开头(平台暂未使用缩略图)  默认使用高清
 2023-2-23 追加产品类别TJCL-YXDX
    
  所需参数 img 图片地址
		   type  产品类型
		   isHd  是否为高清图片
		
 */
const dealProductImg = function(img, type) {
    let url = "";

    // let midPreBL = "/upload/product/BL/";
    let midPreJL = "/upload/product/JL/";
    let midPreSJB = "/upload/product/SJB/";
    let midPreTD = "/upload/product/TD/";
    let midPreTJ = "/upload/product/TJ/";
    let midPreYXB = "/upload/product/YXB/";
    //各类图片总数 -1  排序从0开始
    // let BLnum = 82;
    let JLnum = 75;
    let SJBnum = 7;
    let TDnum = 46;
    let TJnum = 2;
    let YXBnum = 2;
    if (img) {
        url = img
    } else {
        let midPre = "";
        let x = 0,
            y = 0;
        let bs = "";
        if (type == "DZJG-SX" || type == "DZJG-GQGJ" || type == "DZJG-PLJ" || type == "DZJG-DXJ" || type == "DZJG-CYJ") {
            bs = "JL";
            midPre = midPreJL;
            y = JLnum;
        } else if (type == "TJCL-YXB" || type == "TJCL-YXDX") {
            bs = "YXB";
            midPre = midPreYXB;
            y = YXBnum;
        } else if (type == "TJCL-GQG" || type == "TJCL-CYB" || type == "TJCL-DXB" || type == "TJCL-PLB" || type == "TJCL-BTW") {
            bs = "TJ";
            midPre = midPreTJ;
            y = TJnum;
        } else if (type == "TJCL-SJB") {
            bs = "SJB";
            midPre = midPreSJB;
            y = SJBnum;
        } else if (type == "TJCL-TD") {
            bs = "TD";
            midPre = midPreTD;
            y = TDnum;
        } else {
            midPre = '/upload/';
            x = 1;
            y = 1;
        }
        let imgName = "HD" + bs + Math.round(Math.random() * (y - x) + x) + ".jpg";

        url = imgPre() + midPre + imgName;
    }
    return url
}


const dealTime = function(type, time) { //获取当前时间并且格式化
    var date;
    if (!time) {
        date = new Date();
    } else {
        date = new Date(time);
    }
    var year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate(),
        hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
        minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
        second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    month >= 1 && month <= 9 ? (month = "0" + month) : "";
    day >= 0 && day <= 9 ? (day = "0" + day) : "";
    let timer = '';
    if (type == "yyyy-MM-dd") {
        timer = year + "-" + month + "-" + day;
    } else if (type == "yyyy-MM-dd hh:mm:ss") {
        timer = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    } else if (type == "hh:mm") {
        timer = hour + ":" + minute
    } else if (type == "local_id") {
        timer = date.getTime() + second + Math.round(Math.random());
    } else if (type == '年月') {
        timer = year + "年" + month + "月";
    } else if (type == "prepareAt") {
        timer = year + "年" + month + "月" + day + "日" + hour + "时";
    } else if (type == "prepareAt_c") {
        timer = year + "年" + month + "月" + day + "日";
    } else if (type == "yyyy/MM/dd") {
        timer = year + "/" + month + "/" + day;
    } else {
        timer = year + "年" + month + "月" + day + "日" + hour + "时" + minute + "分" + second + "秒";
    }
    return timer;
}


const dealDdState = function(state) { //对订单状态进行处理，返回对应的文字
    let stateTip = '',
        orderState = '', //订单给用户展示的状态 0-未付款 2-已付款 3-已完成
        orderStr = '',
        stateTipColor = '#00BFFF';
    switch (+state) {
        case 0:
            stateTip = '需求确认中';
            orderState = 0;
            orderStr = '未付款';
            break;
        case 1:
            stateTip = '等待报价';
            orderState = 0;
            orderStr = '未付款';
            break;
        case 2:
            stateTip = '已出价待确认';
            orderState = 0;
            orderStr = '未付款';
            break;
        case 3:
            stateTip = '等待付款';
            orderState = 0;
            orderStr = '未付款';
            break;
        case 4:
            stateTip = '已付款';
            orderState = 1;
            orderStr = '已付款';
            break;
        case 5:
            stateTip = '加工中';
            orderState = 1;
            orderStr = '已付款';
            break;
        case 6:
            stateTip = '配送中';
            orderState = 1;
            orderStr = '已付款';
            break;
        case 7:
            stateTip = '已签收';
            orderState = 2;
            orderStr = '已完成';
            break;
        case 8:
            stateTip = '已完成';
            orderState = 2;
            orderStr = '已完成';
            break;
        case 9:
            stateTip = '用户已取消';
            stateTipColor = '#909399';
            orderState = 2;
            orderStr = '已完成';
            break;
        case 10:
            stateTip = '平台已关闭';
            orderState = 2;
            orderStr = '已完成';
            stateTipColor = '#909399';
            break;
            //更多自定义
    }
    return {
        stateTip,
        stateTipColor,
        orderState,
        orderStr
    };
}


/**
 * 转换两个后台接口返回的json数据大写差异
 * @param {*} data 
 * @param {*} type 需要转换的类型
 * @returns 
 */
const transferJSONData = function(data, type) {
    var newObj = {};
    switch (type) {
        case "Customer":
            newObj = {
                "custid": data.CUSTID,
                "custacc": data.CUSTACC,
                "custname": data.CUSTNAME,
                "pwd": data.PWD,
                "ywlx": data.YWLX,
                "cert": data.CERT,
                "kpxx": data.KPXX,
                "wtsqs": data.WTSQS,
                "frdb1": data.FRDB1,
                "frdb2": data.FRDB2,
                "hkyhzh": data.HKYHZH,
                "hkyhmc": data.HKYHMC,
                "hkyhqc": data.HKYHQC,
                "nsrzl": data.NSRZL,
                "sort": data.SORT,
                "nsrzz": data.NSRZZ,
                "state": data.STATE,
                "statemsg": data.STATEMSG,
                "addr": data.ADDR,
                "clnx": data.CLNX,
                "zczj": data.ZCZJ,
                "ncz": data.NCZ,
                "cfmj": data.CFMJ,
                "craft": data.CRAFT,
                "sbxx": data.SBXX,
                "shxydm": data.SHXYDM,
                "clrq": data.CLRQ,
                "ygrs": data.YGRS,
                "cfgs": data.CFGS,
                "lxr": data.LXR,
                "lxdh": data.LXDH,
                "zycp": data.ZYCP,
                "logo": data.LOGO,
                "cpyt": data.CPYT,
                "frdb": data.FRDB,
                "remark": data.REMARK,
                "vipid": data.VIPID,
                "regtime": data.REGTIME,
                "wxOpenid": data.WX_OPENID,
                "wxName": data.WX_NAME,
                "wxHeadimgurl": data.WX_HEADIMGURL,
                "id": data.ID,
                "limit": data.LIMIT,
                "wxUnionid": data.WX_UNIONID,
                "xyje": data.XYJE,
                "custuuid": data.CUSTUUID,
                "audit": data.AUDIT,
                "personalName": data.PERSONAL_NAME,
                "personalPhone": data.PERSONAL_PHONE,
                "personalIdcard": data.PERSONAL_IDCARD,
                "personalIdcardGh": data.PERSONAL_IDCARD_GH,
                "personalIdcardRx": data.PERSONAL_IDCARD_RX,
                "companyName": data.COMPANY_NAME,
                "companyPhone": data.COMPANY_PHONE,
                "companyLicense": data.COMPANY_LICENSE,
                "companyLicenseImg": data.COMPANY_LICENSE_IMG,
                "registerWay": data.USER_LEVEL,
            };
            data = Object.assign(data, newObj);
            break;
        case "MMOItem":
            newObj = {
                "id": data.ID,
                "orderUuid": data.ORDER_UUID,
                "createId": data.CREATE_ID,
                "createAt": data.CREATE_AT,
                "status": data.STATUS,
                "name": data.NAME,
                "steel": data.STEEL,
                "cost": data.COST,
                "price": data.PRICE,
                "thickness": data.THICKNESS,
                "width": data.WIDTH,
                "length": data.LENGTH,
                "count": data.COUNT,
                "weight": data.WEIGHT,
                "unit": data.UNIT,
                "shipmentCost": data.SHIPMENT_COST,
                "storageCost": data.STORAGE_COST,
                "formula": data.FORMULA,
                "size": data.SIZE,
                "lljg": data.LLJG,
                "ddjg": data.DDJG,
                "jsje": data.JSJE,
                "remark": data.REMARK,
                "itProdname": data.IT_PRODNAME,
                "itProdid": data.IT_PRODID,
                "itCpph": data.IT_CPPH,
                "itCpphid": data.IT_CPPHID,
                "itCd": data.IT_CD,
                "itKd": data.IT_KD,
                "itHd": data.IT_HD,
                "itCpgg": data.IT_CPGG,
                "itDhl": data.IT_DHL,
                "itZl": data.IT_ZL,
                "code": data.CODE,
                "image": data.IMAGE,
                "pricePt": data.PRICE_PT,
                "level": data.LEVEL,
                "bl": data.BL,
                "bm": data.BM,
                "hd": data.HD,
                "sd": data.SD,
                "dj": data.DJ,
                "qd": data.QD,
                "errmargin": data.ERRMARGIN,
                "delivdate": data.DELIVDATE,
                "prodid": data.PRODID,
                "packageInfo": data.PACKAGE_INFO,
                "pzyh": data.PZYH,
                "goodsImg": data.GOODS_IMG,
                "packingCost": data.PACKING_COST,
                "discountCost": data.DISCOUNT_COST,
                "grade": data.GRADE,
                "pzyhjg": data.PZYHJG,
                "processingCost": data.PROCESSING_COST,
                "orderitemid": data.ORDERITEMID,
                "cdjj": data.CDJJ,
                "kdjj": data.KDJJ,
                "yhdj": data.YHDJ,
                "yhjg": data.YHJG,
                "use": data.USE,
                "pzyhPrice": data.PZYH_PRICE,
                "pzyhUnit": data.PZYH_UNIT,
                "pzyhRemark": data.PZYH_REMARK,
                "tpackage": data.PACKAGE
            };
            data = Object.assign(data, newObj);
            break;
        default:
            break;
    }


    return data;

}


/**
 * 保留小数点几位数, 自动补零, 四舍五入
 * @param num: 数值
 * @param digit: 小数点后位数
 * @returns string
 * fn_myFixed
 */
const myFixed = function(num, digit) {
    if (digit === undefined) {
        digit = 2;
    }
    if (Object.is(parseFloat(num), NaN)) {
        return console.log(`传入的值：${num}不是一个数字`);
    }
    num = parseFloat(num);
    let newNum = (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit) * 1;
    return newNum;
}

export default {
    baseURL,
    dealProductImg,
    customerPrve,
    newCenterUrl,
    dealTime,
    dealDdState,
    transferJSONData,
    myFixed,
	serveBaseUrl,
	serveBaseUrl_old,
	serveBaseUrl_wang
}